import { Navigate, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Schützt eine Route gegen nicht angemeldete Zugriffe.
 * Ohne gültiges Access-Token im Storage erfolgt eine Weiterleitung zur Login-Seite.
 *
 * Hinweis: Dies ist nur eine clientseitige UX-Absicherung. Die eigentliche
 * Autorisierung wird serverseitig pro Endpunkt erzwungen; ein manipuliertes
 * localStorage-Flag verschafft keinen Zugriff auf Backend-Daten.
 */
const hasToken = (): boolean => {
  try {
    return Boolean(localStorage.getItem("accessToken"));
  } catch {
    return false;
  }
};

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const location = useLocation();

  if (!hasToken()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
